import { IAppComponentProps } from "../../../components";
import React from "react";
import { Card, Col, Collapse, Form, FormInstance, Input, Row, Typography } from 'antd';
import { PortalFormItem } from "../../../components/FormUtils";
import { getI18n } from "../../../utils/Utils";
import { FormattedMessage, useIntl } from "react-intl";
import { CaretRightOutlined } from "@ant-design/icons";
import { Form_Item } from "../componets/FormItem-component";
import { getControlRuleset } from "../RulesEngine";
import { useAppDispatch, useAppSelector } from "../../../main/hooks";
import { updateCollapsedState } from "../IStoredDocumentRecordSlice";
import Paragraph from 'antd/es/typography/Paragraph';

type SuppliersBankingDetailsProps = {
  form : FormInstance<any>;
  onlyDisplayNote:boolean;
} & IAppComponentProps;

const SuppliersBankingDetails: React.FunctionComponent<SuppliersBankingDetailsProps> = (props) => {
  const intl = useIntl();
  const {  document } = useAppSelector((state) => state.document);
  const rules = useAppSelector((state) => state.rules);
  const dispatch = useAppDispatch();


  return (
    <>
        <Row key={"companyDetailsRow"} gutter={24}>
            <Col span={24}>
                {
           props.onlyDisplayNote? <Collapse
                   bordered={true}
                   expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                   expandIconPosition={"left"} className={"ml-10"}
                   activeKey={document.collapsedState}
                   onChange={(newActiveKeys) => {
                       // otherwise panels couldn't be open/closed by click
                       dispatch(updateCollapsedState(newActiveKeys));
                   }}>
               <Collapse.Panel key={"bankingDetailNotes"}
                               forceRender={true}
                               header={getI18n("supplierdetails-supplier-banking-panel-header",
                                   "Banking Details", intl)}>
                   <Card key={"supplierBankingKey"}>
                       <Typography.Paragraph>
                           {intl.formatMessage({id:'ecap-bank-details-notes'})}
                           &nbsp;
                           <Typography.Link href={intl.formatMessage({id:'ecap-bank-details-link-url'})} target="_blank">
                               {intl.formatMessage({id:'ecap-bank-details-link-text'})}
                           </Typography.Link>
                       </Typography.Paragraph>
                   </Card>
               </Collapse.Panel>
               </Collapse>
               :
      <Collapse
        defaultActiveKey={2}
        className={"ml2"}
        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
        activeKey={document.collapsedState}
        onChange={(newActiveKeys) => {
          // otherwise panels couldn't be open/closed by click
          dispatch(updateCollapsedState(newActiveKeys));
}}

      >
        <Collapse.Panel key={5.5}
                        forceRender={true}
                        header={getI18n("supplierdetails-supplier-banking-panel-header",
                                                  "Banking Details", intl)}>
          <Card key={"supplierBankingKey"} size={"small"}
                className={"ml-10"}>
            <Row gutter={24}>
              <Col span={10}>
                <Form_Item name={["supplierDetails", "bankIban"]}
                           itemRules={getControlRuleset("IBAN", props.form, rules, document)}
                           label={getI18n("supplierdetails-supplier-banking-iban",
                                                    "IBAN", intl)}>
                  <Input placeholder={getI18n("supplierdetails-supplier-banking-iban", "IBAN", intl)}
                         allowClear={true} maxLength={34} />
                </Form_Item>
                <Form.Item name={["supplierDetails", "bankAccountNumber"]}
                           label={getI18n("supplierdetails-supplier-banking-bankAccount",
                                                    "Bank Account", intl)}>
                  <Input placeholder={getI18n("supplierdetails-supplier-banking-bankAccount", "Bank Account", intl)}
                         allowClear={true} maxLength={20} />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item name={["supplierDetails", "bankSwiftBicNumber"]}
                           label={getI18n("supplierdetails-supplier-banking-swiftBic",
                                                    "Swift / BIC" , intl)}>
                  <Input placeholder={getI18n("supplierdetails-supplier-banking-swiftBic", "Swift / BIC", intl)}
                         allowClear={true} maxLength={11} />
                </Form.Item>

                <Form.Item name={["supplierDetails", "bankBranchCode"]}
                           label={getI18n("supplierdetails-supplier-banking-branchCode",
                                                    "Branch Code", intl)}>
                  <Input placeholder={getI18n("supplierdetails-supplier-banking-branchCode", "Branch Code", intl)}
                         allowClear={true} maxLength={11} />
                </Form.Item>
          </Col>
            </Row>
          </Card>
        </Collapse.Panel>
      </Collapse>
    }
            </Col>
        </Row>
    </>
  );
};

export default SuppliersBankingDetails;